export const pokpokSpacing = {
  1: 4,
  2: 8,
  4: 16,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
  20: 80,
} as const;

export const pokpokRadius = {
  micro: 4,
  control: 8,
  container: 12,
  full: 9999,
} as const;

export const pokpokBreakpoints = {
  compact: 480,
  tablet: 768,
  desktop: 1024,
  wide: 1280,
} as const;

export const pokpokGrid = {
  compact: {columns: 4, margin: 16, gutter: 16},
  tablet: {columns: 8, margin: 24, gutter: 24},
  desktop: {columns: 12, margin: 32, gutter: 24},
} as const;

export const pokpokElevation = {
  none: 'none',
  low: '0 1px 2px rgb(26 29 35 / 10%)',
  medium: '0 8px 24px rgb(26 29 35 / 12%)',
  high: '0 16px 40px rgb(26 29 35 / 16%)',
} as const;

export const pokpokMotion = {
  fast: 175,
  medium: 410,
  slow: 975,
  reduced: 0,
} as const;

export const pokpokIconSize = {
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
} as const;

export const pokpokFocusRing = {
  width: 2,
  offset: 2,
  color: '#1D4ED8',
} as const;

export type PokpokBreakpoint = keyof typeof pokpokBreakpoints;
export type PokpokElevation = keyof typeof pokpokElevation;
export type PokpokIconSize = keyof typeof pokpokIconSize;
